import { AxiosRequestConfig, HTTPClient } from '@abaco/web-common/src/HTTP';
import { Fertilizer } from '../models/FertilizerModel';

export default class PrecisionApi {
    private http: HTTPClient;
    public context = "FARM_CROP_PLAN_MAP";

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getPlotData(pkCuaa: number, plot_id: number, campaign_id: number | null): Promise<any> {
        const url = `/fertilizer-plan/api/v1/farm/${pkCuaa}/parcels/plots/${plot_id}/data`;
        const params = campaign_id
            ? { campaign_year: campaign_id }
            : {}
        return (await this.http.get(url, { params })).data
    }

    public async getManureComposition(): Promise<any> {
        const url = `/fertilizer-plan/api/v1/manure-compositions`;
        return (await this.http.get(url)).data
    }

    public async getIrrigationTypes(): Promise<any> {
        const url = `/fertilizer-plan/api/v1/irrigation-types`;
        return (await this.http.get(url)).data
    }

    public async getFertilizerPlanPDF(plan_id: number): Promise<any> {
        const url = `/fertilizer-plan/api/v1/plans/${plan_id}/pdf`;
        return (await this.http.get(url)).data
    }

    public async getFertilizerPlans(pkCuaa: number, plot_id: number): Promise<any> {
        const url = `/fertilizer-plan/api/v1/farm/${pkCuaa}/parcels/plots/${plot_id}/plans`;
        return (await this.http.get(url)).data
    }
    
    public async addFertilizerPlan(pkCuaa: number, campaign: number, parcel_id: number, params: any, plot_id: number): Promise<any[]> {
        // in futuro il plot id non servira piu
        const url = `/fertilizer-plan/api/v1/farm/${pkCuaa}/campaigns/${campaign}/parcels/${parcel_id}/lots/${plot_id}`;
        return (await this.http.post(url, params)).data
    }

    public async removePlan(pkCuaa: number, planId: number) {
        const url = `/fertilizer-plan/api/v1/farm/${pkCuaa}/plans/${planId}`;
        return (await this.http.delete(url)).data
    }
    
    async downloadPDF() {
        const url = `/fertilizer-plan/api/v1/plans/urlPdfservice`;
        return (await this.http.get(url)).data
    }

    public async getFails(pkCuaa: number, campaign: number) {
        const url = `/fertilizer-plan/api/v1/farm/${pkCuaa}/fails/campaign/${campaign}`;
        return (await this.http.get(url)).data
    }
}
